import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSeparator = _resolveComponent("BaseSeparator")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), { class: "base-list-item" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_BaseSeparator)
    ]),
    _: 3
  }))
}